// removed by extract-text-webpack-plugin
module.exports = {"lightPrimary":"#36997c","theme":"#005FAB","menuBgColor1":"#262C33","menuBgColor2":"#262C33","menuTxtColor":"#fff","menuActiveTxtColor":"#fff","menuActiveBgColor":"#6b7077","searchItemMargin":"12px","dataIndexBg":"#081027","dataIndexBlockBg":"rgba(255,255,255,0.08)"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/theme/variables.scss
// module id = WY07
// module chunks = 3